module.exports = __webpack_public_path__ + "static/img/404.9f74df0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/404.jpg
// module id = kvT1
// module chunks = 1